import loadable from '@loadable/component';

export const PracticalcaravanSiteWrapper = loadable(
  () => import(/* webpackChunkName: "practicalcaravan-site" */ './PracticalcaravanSiteWrapper'),
);
